export const NEXUS_DEMO_EXECUTION_SUMMARY_TABLE = [
  {
    Phase: '**Step 1 — Plan**',
    'Key Execution': 'GitHub repo read → requirements summarized → dev plan authored',
    Result: 'Phased roadmap with conflict-detection and benchmark queries',
    Status: '**✅ PASS**',
  },
  {
    Phase: '**Step 2 — Website**',
    'Key Execution': 'HTML site built → static build → preview opened',
    Result: '*2,785-line* procurement site in artifact panel',
    Status: '**✅ PASS**',
  },
  {
    Phase: '**Step 2 — Integrations**',
    'Key Execution': 'Salesforce + HubSpot + Procurify APIs *(19 files)* → Stripe + Mailchimp verified',
    Result: 'CRM, SRM, and procurement endpoints live',
    Status: '**✅ PASS**',
  },
  {
    Phase: '**Step 2 — Demo Test**',
    'Key Execution': 'Playwright demo-user checkout → live CRM lead + procurement trigger',
    Result: 'Lead ID `58930100001234567` · PR `PR-20481`',
    Status: '**✅ PASS**',
  },
  {
    Phase: '**Step 3 — GCP (9 phases)**',
    'Key Execution': 'Project → DB → backend → frontend → LB → DNS → SSL → monitoring → CI/CD',
    Result: 'Production URL live with HTTPS',
    Status: '**✅ PASS**',
  },
  {
    Phase: '**DNS Confirmation**',
    'Key Execution': 'Nameserver propagation verified after your *"done"*',
    Result: 'SSL certificate active on `app.nexusb2b.com`',
    Status: '**✅ PASS**',
  },
]

export const NEXUS_DEMO_JOURNEY_WRAP_UP_MARKDOWN =
  '🎯 **NexusB2B is fully operational** — from requirements to production. Your site is live at `app.nexusb2b.com`, Salesforce + HubSpot + Procurify triggers are firing, and GCP infrastructure is monitored with automated deploys.'
